'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.waveforms.edit', [])
  .controller('WaveformsEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/waveforms/edit/index.js